import { Component, OnDestroy, OnInit } from '@angular/core'
import { DatePipe } from '@angular/common'
import { LanguageService } from '@core/services/language.service'

@Component({
  selector: 'epic-date',
  standalone: true,
  imports: [DatePipe],
  template: `
    <div class="epic-date">
      {{ currentDate | date: 'fullDate':undefined:locale }}
    </div>
  `,
  styleUrl: './date.component.scss',
})
export class DateComponent implements OnInit, OnDestroy {
  currentDate: Date = new Date()
  timerID?: any
  locale = 'en-US'

  constructor(private languageService: LanguageService) {}

  ngOnInit() {
    const stored = this.languageService.getLocalStorageLanguage
    if (stored) {
      this.locale = stored
    }

    this.timerID = setInterval(() => {
      this.currentDate = new Date()
    }, 30_000)
  }

  ngOnDestroy() {
    if (this.timerID) {
      clearInterval(this.timerID)
    }
  }
}